module.exports = "\r\n.tfoot-form-control{\r\n    width: 150px;\r\n}\r\n.btn-group .btn{\r\n    min-width: 5px;\r\n}\r\n.btn-xs i, .btn-xs .fa, .btn-group .fa{\r\n    color: white;\r\n    font-size: 15px;\r\n}\r\n.btn-xs{\r\n    width: 24px !important;\r\n    background-color: #6c757d;\r\n    padding: 0px;\r\n    border: 0px;\r\n    border-radius: 3px;\r\n    display: inline-block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/Manage/vender/vender-grid/vender-grid.component.css
// module id = ./src/app/Pages/Manage/vender/vender-grid/vender-grid.component.css
// module chunks = main